import axios from "axios";

export default class UsuariosEspecialidadesService {
  allEspecialidadesDeUnMedico(id) {
    return axios.get(
      process.env.VUE_APP_API_PUBLIC + "usuario-especialidad/" + id
    );
  }
  crearUsuarioEspecialidad(data) {
    return axios.post(
      process.env.VUE_APP_API_PUBLIC + "usuario-especialidad/create",
      data
    );
  }
  updateUsuarioEspecialidad(data) {
    return axios.put(
      process.env.VUE_APP_API_PUBLIC + "usuario-especialidad/update",
      data
    );
  }

  deleteUsuarioEspecialidad(data) {
    return axios.delete(
      process.env.VUE_APP_API_PUBLIC + "usuario-especialidad/delete",
      { data: data }
    );
  }
  /* crearTarifa(data) {
    return axios.post(process.env.VUE_APP_API_PUBLIC + "tarifas/create", data);
  }
  allTarifas() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "tarifas/todas");
  }
  obtenerLaUltimaTarifa() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "tarifas/ultima");
  } */
}
